import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  static values = {
    messageId: Number,
    otherUser: Number,
    context: Object
  }

  static targets = [ 'returnFocus' ]

  openReply() {
    this.setReplyModalTitle()
    this.clearContextTable()
    this.fillContextTable()
    this.updateReplyFormInputValues()
    this.handleFocusOnModalClose()
    this.openReplyModal()
  }

  setReplyModalTitle() {
    const modalElement = document.getElementById('reply-modal')
    const modalTitle = modalElement.getElementsByClassName('modal-title')[0]

    modalTitle.textContent = `Reply to ${this.element.dataset.messagesModalsOtherUserName}`
  }

  clearContextTable() {
    const contextTableBodyElement = document.getElementById('context-table-body')
    contextTableBodyElement.innerHTML = ''
  }

  fillContextTable() {
    this.addRowForMessage(this.contextValue, true)

    if (this.contextValue.children) {
      this.contextValue.children.forEach(childMessagePartial => {
        this.addRowForMessage(childMessagePartial)
      })
    }
  }

  addRowForMessage(messagePartial, is_parent = false) {
    const contextTableBodyElement = document.getElementById('context-table-body')

    let row = document.createElement('tr')

    if (is_parent) {
      row.className = 'table-active'
    }

    let tds = [
      document.createElement('td'),
      document.createElement('td'),
      document.createElement('td')
    ]
    tds[0].textContent = messagePartial.sender_name
    tds[1].textContent = messagePartial.content
    tds[2].textContent = new Date(messagePartial.updated_at).toLocaleDateString()

    tds.forEach(td => { row.append(td) })

    contextTableBodyElement.append(row)
  }

  updateReplyFormInputValues() {
    const parentIdInput = document.getElementById('message_parent_id')
    const recipientIdInput = document.getElementById('message_recipient_id')

    parentIdInput.value = this.messageIdValue
    recipientIdInput.value = this.otherUserValue
  }

  handleFocusOnModalClose() {
    const modalElement = document.getElementById('reply-modal')
    modalElement.addEventListener('hidden.bs.modal', event => {
      this.returnFocusTarget.focus()
    })
  }

  openReplyModal() {
    const modal = new bootstrap.Modal('#reply-modal');
    modal.show();
  }
}
